module.exports = __webpack_public_path__ + "img/padlock-white.ff4cae3d.svg";